import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav-bar" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "nav" }

import { useRouter } from 'vue-router'
    import { ref } from 'vue'
    import { useStore } from 'vuex'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'menu',
  setup(__props) {

    const router = useRouter()
    const store = useStore()
    let pathStr = ref('')
    const toPath = (path:string) => {
        router.push(path)
    }

    pathStr.value = router.currentRoute.value.fullPath


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            class: _normalizeClass({'active': _unref(pathStr) == '/'})
          }, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toPath('/')))
            }, [...(_cache[7] || (_cache[7] = [
              _createTextVNode("首页", -1),
              _createElementVNode("br", null, null, -1)
            ]))])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'active': _unref(pathStr).indexOf('/walk-into-zmq') > -1})
          }, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toPath('/walk-into-zmq')))
            }, [...(_cache[8] || (_cache[8] = [
              _createTextVNode("走进自贸区", -1),
              _createElementVNode("br", null, null, -1)
            ]))])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'active': _unref(pathStr).indexOf('/do-things-online') > -1})
          }, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toPath('/do-things-online')))
            }, [...(_cache[9] || (_cache[9] = [
              _createTextVNode("网上办事", -1),
              _createElementVNode("br", null, null, -1)
            ]))])
          ], 2),
          false
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass({'active': _unref(pathStr).indexOf('/tax-center') > -1})
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("a", {
                  href: "https://www.kfzmt.gov.cn/article/36?pid=3",
                  target: "_blank"
                }, [
                  _createTextVNode("政策法规"),
                  _createElementVNode("br")
                ], -1)
              ]))], 2))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            class: _normalizeClass({'active': _unref(pathStr).indexOf('/tax-center') > -1})
          }, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toPath('/tax-center')))
            }, [...(_cache[11] || (_cache[11] = [
              _createTextVNode("涉税咨询", -1),
              _createElementVNode("br", null, null, -1)
            ]))])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'active': _unref(pathStr).indexOf('/party-building') > -1})
          }, [
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (toPath('/party-building')))
            }, [...(_cache[12] || (_cache[12] = [
              _createTextVNode("党建之窗", -1),
              _createElementVNode("br", null, null, -1)
            ]))])
          ], 2),
          _cache[15] || (_cache[15] = _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "http://221.176.159.151:8888/gcjs.jspx",
              target: "_blank"
            }, [
              _createTextVNode("工程建设"),
              _createElementVNode("br")
            ])
          ], -1)),
          _createElementVNode("li", {
            class: _normalizeClass({'active': _unref(pathStr).indexOf('/hcp') > -1})
          }, [
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (toPath('/hcp')))
            }, [...(_cache[13] || (_cache[13] = [
              _createTextVNode("好差评", -1),
              _createElementVNode("br", null, null, -1)
            ]))])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({'active': _unref(pathStr).indexOf('/government-affairs') > -1})
          }, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (toPath('/government-affairs')))
            }, [...(_cache[14] || (_cache[14] = [
              _createTextVNode("政务公开", -1),
              _createElementVNode("br", null, null, -1)
            ]))])
          ], 2),
          _cache[16] || (_cache[16] = _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "http://www.kfsfq.gov.cn/cxythsfq/c01011/pc/list.html",
              target: "_blank"
            }, [
              _createTextVNode("政策解读"),
              _createElementVNode("br")
            ])
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})